<div id="header-cart">
  <!-- CART DROPDOWN TOGGLE -->
  <div 
    id="header-cart-icon"
    #icon
    class="fx-row fx-row-h-center fx-row-v-center"
    [attr.data-cy]="cart ? 'spc-cart header-cart-icon' : null"
    [class.active]="isActive"
    (click)="toggleMenu()">
    <mat-icon 
      svgIcon="shopping-bag"
      [ngClass]="cart && !cart?.isEmpty ? 'small-icon' : ''"
      (click)="(null)">
    </mat-icon>
    @if (cart?.totalItems > 0) {
      <div
        id="header-cart-icon-count"
        (click)="(null)"
        [attr.data-cy]="cart ? 'spc-cart-item-count' : null">
        {{ cart.totalItems }}
      </div>
    }
  </div>
  <!-- EMPTY CART MESSAGE DROPDOWN -->

  @if (cart?.isEmpty) {
    <div id="header-cart-menu" #menu [class]="isActive ? 'active mat-elevation-z2' : ''">
      <span class="header-cart-menu-message">Your cart is empty</span>
    </div>
  }

  <!-- CART MENU DROPDOWN -->

  @if (!cart?.isEmpty) {
    <div id="header-cart-menu" #menu [class]="isActive ? 'active mat-elevation-z2' : ''">
      <h3 id="header-cart-menu-total-items">{{ cart?.totalItems }} ITEMS</h3>
      <div id="header-cart-menu-items" (scroll)="showScrollMessage = false" #menuItems data-cy="spc-cart-item-list">
        @for (item of items; track $index) {
          <div class="header-cart-menu-item fx-row fx-row-h-center">
            @if (item?.imageUrl) {
              <img
                class="header-menu-cart-item-image"
                [src]="getWebpImg(item.imageUrl)"
                [alt]="item.description"
                />
            }
            <div class="header-cart-menu-item-text fx-fill-remaining">
              <div class="header-cart-menu-item-text-description">
                <a class="link-gray truncate-ellipsis" [routerLink]="'/' + item.urlComponent" (click)="closeMenu()">{{
                  item.description
                }}</a>
              </div>
              <span class="header-cart-menu-item-text-price">
                {{ item.quantity }} &#64; {{ item.price | currency }} each |
                <span class="header-cart-menu-item-text-total">{{ item.totalPrice | currency }}</span>
              </span>
            </div>
          </div>
        }
      </div>
      <h4 id="header-cart-menu-subtotal" class="fx-row fx-row-h-space-between">
        <span id="header-cart-scroll-message" [class.show]="showScrollMessage">
          Scroll for More <mat-icon>double_arrow</mat-icon>
        </span>
        <span>SUBTOTAL:</span>
        <span>{{ cart?.summary.subtotal | currency }}</span>
      </h4>
      <div id="header-cart-menu-buttons" class="mt-2">
        <a
          data-cy="header-cart-menu-proceed-btn"
          class="header-cart-menu-button button-secondary button-base px-1 mr-1"
          routerLink="/checkout/cart"
          (click)="closeMenu()"
          >{{ isCheckout ? "Edit Your Cart" : isCart ? "View Your Cart" : "Proceed to Cart" }}</a
          >
          <a
            class="header-cart-menu-button button-primary px-1 button-base"
            data-cy="spc-checkout-button"
            (click)="openAuthDialog(); closeMenu()"
            >Checkout</a
            >
          </div>
        </div>
      }
    </div>
